import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Work Order Status List with Query (for remote operations)
export const getWorkOrderStatusListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WORK_ORDER_STATUSES}?${stringifyParams(
			params
		)}`
	);
};

// Get Work Order Status List
export const getWorkOrderStatusList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WORK_ORDER_STATUSES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Work Order Status
export const getWorkOrderStatus = work_order_status_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WORK_ORDER_STATUS}${work_order_status_id}`
	);
};

// Add New Work Order Status
export const addNewWorkOrderStatusApi = work_order_status => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WORK_ORDER_STATUS}`,
		work_order_status
	);
};

// Update Work Order Status
export const updateWorkOrderStatusApi = work_order_status => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WORK_ORDER_STATUS}${work_order_status._id}`,
		work_order_status
	);
};

// Delete Work Order Status
export const deleteWorkOrderStatusApi = work_order_status_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WORK_ORDER_STATUS}${work_order_status_id}`
	);
};

// Check if Work Order Status Exists
export const checkWorkOrderStatusExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_WORK_ORDER_STATUS_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
